import Grid from '@mui/material/Grid';
import type { SxProps, Theme } from '@mui/material/styles';
import { theme } from '@openx/components-core/lib/theme/theme.ts';
import { useEffect, useMemo } from 'react';

import { useDealContext } from '../../utils/context/DealContext.tsx';

import { DealForecastContent } from './components/DealForecastContent.tsx';
import { renderStateComponent } from './utils/renderStateComponent.tsx';

const styles: { [key: string]: SxProps<Theme> } = {
  button: {
    backgroundColor: theme.palette.background.boxLight,
    bottom: theme.spacing(6.5),
    left: 0,
    margin: 0,
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    position: 'sticky',
    zIndex: 5,
  },
  container: {
    height: '100%',
    width: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme => theme.spacing(3),
    maxWidth: '600px',
    minWidth: '352px',
    padding: theme => `${theme.spacing(4)} ${theme.spacing(3)} ${theme.spacing(2)}`,
    width: '100%',
  },
};

export const DealForecast = () => {
  const { useDealForecast } = useDealContext();
  const { forecastState, actions } = useDealForecast();
  const { job_id, loading } = forecastState;
  const StateComponent = useMemo(() => renderStateComponent(forecastState), [forecastState]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: probably needed here
  useEffect(() => {
    return () => {
      actions.resetForecast();
    };
  }, []);

  return (
    <Grid container data-test="deal-forecast-container" sx={styles.container}>
      <Grid sx={styles.content}>
        {StateComponent}
        {job_id && <DealForecastContent job_id={job_id} loading={!!loading} />}
      </Grid>
    </Grid>
  );
};
